import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import type { RecipeGridContentBlock } from '@library/api-menu-experience'
import type { RecipeUUID } from '@library/menu-service'

import { setTutorialViewed } from 'actions/tutorial'
import { useAuth } from 'routes/Menu/domains/auth'
import { useIsTutorialPending } from 'routes/Menu/hooks/useIsTutorialPending'

export const CUSTOMISATION_EDUCATION_TUTORIAL_NAME = 'customisation_education_v2'

const getFirstCustomisableRecipeId = (contentBlock: RecipeGridContentBlock): RecipeUUID | null =>
  contentBlock.items.find((item) => item.customisations?.type === 'ingredients')?.id ?? null

export const useRecipeGridCustomisationEducation = (contentBlock: RecipeGridContentBlock) => {
  const dispatch = useDispatch()
  const { isAuthenticated } = useAuth()
  const isEducationPending = useIsTutorialPending(CUSTOMISATION_EDUCATION_TUTORIAL_NAME)

  const closeEducation = useCallback(() => {
    dispatch(setTutorialViewed(CUSTOMISATION_EDUCATION_TUTORIAL_NAME, 1))
  }, [dispatch])

  return {
    closeEducation,
    recipeIdForEducation:
      isAuthenticated && isEducationPending ? getFirstCustomisableRecipeId(contentBlock) : null,
  }
}
